// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { UPDATE_ORGANIZATION } from "./action";

export function canUpdateOrganization(scope: Scope): boolean {
  return scope.iamActions.includes(UPDATE_ORGANIZATION);
}
